import { h, Component } from 'preact';
import { recentStorage } from '../../lib/storage';
import { Text } from 'preact-i18n';
import { HeaderV2 } from '@cube/blocks';
import StockSymbolTable from '../stock-symbol-table';
import cx from 'classnames';
import style from './style';

const INTL_NS = 'stock-recently-viewed';

export default class RecentlyViewed extends Component {
	state = {
		symbols: []
	};

	getStocksFromStorage = () => {
		let symbols = recentStorage.get('stocks') || [];
		if (symbols.length) this.setState({ symbols });
	}

	componentWillMount() {
		this.getStocksFromStorage();
	}

	render({ abbrv = true }, { symbols }) {
		return (
			<div class={cx(style.stockRecentlyViewed)}>
				<HeaderV2 class={style.header}
					title={(
						<Text id={`${INTL_NS}.recentlyViewed`}>Recently Viewed</Text>
					)}
				/>
				{symbols.length ?
					<StockSymbolTable
						showHeaders={!!symbols.length}
						symbols={symbols}
						abbrv={abbrv}
						columns={['symbolWithName', 'price', 'changePrice', 'changePercent']}
						trackingSource="stock-recently-viewed"
						trackingZone="finance-components"
					/>
					:<div class={cx(style.noRecentStocks)}>
						<Text id={`${INTL_NS}.noStockDataAvailable`}>No stock data available</Text>
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-recently-viewed/stock-recently-viewed.js